export default "<textarea #simplemde></textarea>\n"